<template>
  <div>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="stays"
        :search="search"
        :items-per-page="15"
        :custom-filter="filterItems"
        :footer-props="{
          itemsPerPageOptions: [15, 30, -1],
          itemsPerPageText: $t('table.itemsPerPageText')
        }"
        sort-by="start_date"
        sort-desc
        class="table-cursor"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('search')"
              single-line
              hide-details
            />
            <v-spacer />
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                  to="/manage/edit/stays/add"
                  ><v-icon class="mr-2">mdi-plus-thick</v-icon
                  >{{ $t("button.newItem") }}</v-btn
                >
              </template>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.person="{ item }">
          {{ personFullName(item) }}
        </template>
        <template v-slot:item.organization="{ item }">
          {{ organizationName(item) }}
        </template>
        <template v-slot:item.type="{ item }">
          {{ stayType(item) }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn class="mr-2" color="primary" :to="`/manage/edit/stays/edit/${item.id}`" text icon>
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-icon color="red" @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
      <v-row>
        <v-col class="text-right">
          <VueJsonToCsv :json-data="enrichedStays" csv-title="stays">
            <v-btn text color="secondary" class="mr-2" :disabled="enrichedStays.length < 1">
              <v-icon left>mdi-file-table-box</v-icon>
              <span class="d-none d-md-block">{{ $t('table.exportCSV') }}</span>
              <span class="d-block d-md-none">{{ $t('table.exportCSV_short') }}</span>
            </v-btn>
          </VueJsonToCsv>
        </v-col>
        <v-col>
          <VueJsonToExcel :data="enrichedStays" name="stays.xls">
            <v-btn text color="secondary" :disabled="enrichedStays.length < 1">
              <v-icon left>mdi-microsoft-excel</v-icon>
              <span class="d-none d-md-block">{{ $t('table.exportExcel') }}</span>
              <span class="d-block d-md-none">{{ $t('table.exportExcel_short') }}</span>
            </v-btn>
          </VueJsonToExcel>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import VueJsonToCsv from "vue-json-to-csv";
import VueJsonToExcel from "vue-json-excel";
import stay_model from "@/mixins/model_utils/stay_model";
import filterSearchMixin from '../../mixins/filterSearchMixin.js'
export default {
  mixins: [stay_model, filterSearchMixin],
  components: {VueJsonToCsv, VueJsonToExcel},
  data() {
    return {
      dialog: false,
      search: "",
      stays: [],
      people: [],
      organizations: []
    };
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("table.person"),
          value: "person",
        },
        {
          text: this.$t("table.organization"),
          value: "organization",
        },
        {
          text: this.$t("table.start_date"),
          value: "start_date"
        },
        {
          text: this.$t("table.end_date"),
          value: "end_date"
        },
        {
          text: this.$t("table.type"),
          value: "type"
        },
        {
          text: this.$t("actions"),
          value: "actions",
          width: "10%",
          align: "end",
          filterable: false,
          sortable: false
        }
      ];
    },
    enrichedStays() {
      return this.stays.filter(item => this.filterItems("", this.search, item)).map(stay => {
        return {
          id: stay.id,
          person: this.personFullName(stay),
          organization: this.organizationName(stay),
          responsible: stay.responsible,
          type: this.stayType(stay),
          start_date: stay.start_date,
          end_date: stay.end_date,
        };
      });
    },
  },
  created() {
    this.initialize();
  },

  methods: {
    personFullName(item) {
      const person = this.people.find(person => person.id === item.person);
      return person ? `${person.preferred_name.given_name} ${person.preferred_name.family_name}` : "-";
    },
    organizationName(item) {
      if (!item || item.organization === null || item.organization === undefined) {
        return "-";
      }
      if (typeof item.organization === "string" && item.organization.trim() !== "") {
        return item.organization;
      }
      if (typeof item.organization === "object") {
        if (item.organization.name) {
          return item.organization.name;
        }
        if (item.organization.title) {
          return item.organization.title;
        }
        const organizationId = item.organization.id;
        const organization = this.organizations.find(org => org.id === organizationId);
        return organization ? organization.name : "-";
      }
      const organization = this.organizations.find(organization => organization.id === item.organization);
      return organization ? organization.name : "-";
    },
    stayType(item) {
      return item.type ? this.$t(`form.stay_${item.type}`) : "-";
    },
    initialize() {
      let path = this.$store.state.endpoint + "/stay";
      axios
        .get(path)
        .then(response => {
          let path = this.$store.state.endpoint + "/personName";
          axios
            .get(path)
            .then(response => {
              this.people = response.data;
            })
            .catch(error => {
              console.log(error);
            });
          path = this.$store.state.endpoint + "/organization";
          axios
            .get(path)
            .then(response => {
              this.organizations = response.data;
            })
            .catch(error => {
              console.log(error);
            });
          this.stays = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    deleteItem(item) {
      if (confirm(this.$t('message.confirm.delete'))) {
        let path = this.$store.state.endpoint + "/stay/" + item.id;
        axios
          .delete(path)
          .then(response => {
            const index = this.stays.indexOf(item);
            this.stays.splice(index, 1);
            this.$store.commit("alert", {
              color: "success",
              text: this.$t('message.correct.deleteItem')
            });
          })
          .catch(error => {
            console.log(error);
            this.$store.commit("alert", {
              color: "error",
              text: error.response
            });
          });
      }
    },
    filterItems(value, search, item) {
      const search_array = search
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .split(",")
        .map(x => x.trim());
      console.log(item);
      const customValue = (
        this.personFullName(item) +
        " " +
        item.start_date +
        " " +
        item.end_date +
        " " + 
        "type:" + item.type +
        " " + 
        this.organizationName(item)
        )
        .toString()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
      return (
        customValue != null &&
        search_array != null &&
        typeof customValue === "string" &&
        search_array.every(function(search){ return customValue.indexOf(search) !== -1 })
      );
    },
  }
};
</script>
